

























import AbpBase from "@/lib/abpbase"
import {Component, Prop} from "vue-property-decorator"
import {DeletePatCourse, GetPatCourses} from "@/api/hd"
import AddOrEdit from './addOrEdit.vue'

@Component({
	components: {AddOrEdit}
})
export default class XX extends AbpBase {
	@Prop() patient: any
	addOrEditData: any = {}
	addOrEditShow = false
	query: any = {
		date: '最近一个月',
		dates: []
	}
	loading = false
	data = []
	columns = [
		// {
		// 	type: 'selection',
		// 	width: 60,
		// 	align: 'center'
		// },
		{
			title: '病程记录日期',
			key: 'inputDate',
			width:150,
			render:(h: any, params: any)=>{
				return h('span', this.formatDate(params.row.inputDate))
			}
		}, {
			title: '病程记录',
			render:(h: any, params: any) =>{
				return h('div',{
					props:{
						title: params.row.contentHtml
					},
					title: {
						title: params.row.contentHtml
					}
				},params.row.content)
			}
		}, {
			title: '记录人',
			width:120,
			key: 'creatorUser'
		}, {
			title: '操作',
			width: 180,
			render: (h: any, params: any) => {
				return h('div', [
					h('Button',{
						props:{
							type: 'primary'
						},
						on:{
							click:() => {
								this.editOne(params.row)
							}
						},
						style:{
							marginRight:'15px'
						}
					},'编辑'),
					h('Button',{
						props:{
							type: 'error'
						},
						on:{
							click:() => {
								this.deleteOne(params.row)
							}
						}
					},'删除')
				])
			}
		}
	]

	created() {
		const end = new Date();
		const start = new Date();
		start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
		this.query.dates = [start, end]
		this.init()
	}

	addOne() {
		this.addOrEditData = {
			mode: 'add',
			patient: this.patient
		}
		this.addOrEditShow = true
	}

	saveSuccess() {
		this.addOrEditShow = false
		this.init()
	}

	dateChange(val: string) {
		switch (val) {
			case '全部':
				this.query.dates = []
				this.init()
				break
			case '最近一周':
				this.setDate(7)
				break
			case '最近一个月':
				this.setDate(30)
				break
			case '最近半年':
				this.setDate(182)
				break
			case '最近一年':
				this.setDate(365)
				break
			case '最近三年':
				this.setDate(365 * 3)
				break
		}
	}

	setDate(days: number) {
		const end = new Date()
		let start = new Date()
		start.setTime(start.getTime() - 3600 * 1000 * days * 24);
		this.query.dates = [start, end]
		this.init()
	}

	private async init() {
		let query: any = {
			PatientId: this.patient.id
		}
		if (this.query.dates[0]) {
			query['StartDate'] = this.formatDate(this.query.dates[0])
			query['EndDate'] = this.formatDate(this.query.dates[1])
		}
		let res = await GetPatCourses(query)
		this.data = res.objects
	}

	private editOne(row: any) {
		this.addOrEditData = {
			mode: 'edit',
			patient: this.patient,
			item: row
		}
		this.addOrEditShow = true
	}

	private async deleteOne(row: any) {
		this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning'
		}).then(async () => {
			let res = await DeletePatCourse({Id: row.id})
			this.init()
		}).catch(() => {

		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/electronicMedicalRecord/patient/parts/courseRecord/index.vue